import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ThemeService } from '@app/salon-details/services/theme.service';
import { ICustomerData } from '@app/shared/models/customer-data.model';
import { CustomerService } from '@app/shared/services/customer/customer.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-account-details',
  templateUrl: './customer-account-details.component.html',
  styleUrls: ['./customer-account-details.component.scss']
})
export class CustomerAccountDetailsComponent implements OnInit, OnDestroy {

  customerData: ICustomerData;
  private masterSubscription = new Subscription();
  private themeService = inject(ThemeService);

  constructor(
    private customerService: CustomerService) {
    this.getCustomerData();
  }

  ngOnInit() {
    this.themeService.useDefaultTheme();
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  private getCustomerData(): void {
    const sub = this.customerService.getCustomerData()
      .subscribe((result: ICustomerData) => {
        this.customerData = result;
      });
    this.masterSubscription.add(sub);
  }

}
